import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  InputLabel,
  LinearProgress,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import React, { useEffect, useRef } from "react";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import { Link, useHistory, useParams } from "react-router-dom";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@material-ui/icons/Save";
import _ from "lodash";
import {
  getPurchaseExpense,
  updatePurchaseExpense,
} from "src/redux/actions/purchaseRequest.action";
import { fetchCurrencies } from "src/redux/actions/reference.action";
import { Alert, AlertTitle } from "@material-ui/lab";
import Page from "src/components/Page";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "30ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  breadcrumbContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  formContainer: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  rootLoading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 400,
    padding: 5,
  },
  selectInputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "30ch",
  },
}));

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        if (values.value > 0) {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        } else {
          onChange({
            target: {
              name: props.name,
              value: null,
            },
          });
        }
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default function ExpenseEditComponent() {
  const classes = useStyles();
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  const form = useRef();

  const {
    result: { currencyid },
  } = useSelector((state) => state.loginReducer);

  const { purchaseRequesteExpense } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const { currencies } = useSelector((state) => state.referenceReducer);

  useEffect(() => {
    if (params.id) {
      dispatch(getPurchaseExpense(params.id));
      dispatch(fetchCurrencies(currencyid));
    }
    return () => {};
  }, [params.id]);

  const findExchangeRate = (id) => {
    let result = _.find(currencies.data, { CURRENCY_ID: id });

    if (result) {
      return result.CURRENCY_EXC_ID;
    }

    return 0;
  };

  const renderCurrency = () => {
    return (
      currencies.data &&
      currencies.data.map((i) => (
        <MenuItem key={i.CURRENCY_ID} value={i.CURRENCY_ID}>
          {i.CURRENCY_EXC_CODE} - {i.CURRENCY_EXC_NAME}
        </MenuItem>
      ))
    );
  };

  if (purchaseRequesteExpense.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Purchase request expense!</strong>
        </Alert>
      </div>
    );
  }

  const renderForm = () => {
    if (purchaseRequesteExpense.isLoading) {
      return <LinearProgress color="secondary" />;
    }

    return (
      <Formik
        ref={form}
        enableReinitialize
        initialValues={{
          ...purchaseRequesteExpense.data,
          PREXIDX: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.PREXIDX
            : "",
          EXP01_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP01_AMOUNT
            : "",
          EXP01_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP01_CURR_ID
            : "",
          EXP01_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP01_EXC_RATE
            : "",
          EXP02_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP02_AMOUNT
            : "",
          EXP02_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP02_CURR_ID
            : "",
          EXP02_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP02_EXC_RATE
            : "",
          EXP03_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP03_AMOUNT
            : "",
          EXP03_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP03_CURR_ID
            : "",
          EXP03_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP03_EXC_RATE
            : "",
          EXP04_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP04_AMOUNT
            : "",
          EXP04_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP04_CURR_ID
            : "",
          EXP04_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP04_EXC_RATE
            : "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            let EXP01 = values.EXP01_EXC_RATE * values.EXP01_AMOUNT;
            let EXP02 = values.EXP02_EXC_RATE * values.EXP02_AMOUNT;
            let EXP03 = values.EXP03_EXC_RATE * values.EXP03_AMOUNT;
            let EXP04 = values.EXP04_EXC_RATE * values.EXP04_AMOUNT;

            values.AMOUNT = EXP01 + EXP02 + EXP03 + EXP04;
            values.EXP_TYPE = 1;

            dispatch(updatePurchaseExpense(values, history));

            setSubmitting(false);
          }, 500);
        }}
        validate={(values) => {
          const errors = {};

          // if (!values.EXP01_AMOUNT && values.EXP01_CURR_ID) {
          //   errors.EXP01_AMOUNT = "Required";
          // }

          if (values.EXP01_AMOUNT && !values.EXP01_CURR_ID) {
            errors.EXP01_CURR_ID = "Required";
          }

          // if (!values.EXP02_AMOUNT && values.EXP02_CURR_ID) {
          //   errors.EXP02_AMOUNT = "Required";
          // }

          if (values.EXP02_AMOUNT && !values.EXP02_CURR_ID) {
            errors.EXP02_CURR_ID = "Required";
          }

          // if (!values.EXP03_AMOUNT && values.EXP03_CURR_ID) {
          //   errors.EXP03_AMOUNT = "Required";
          // }

          if (values.EXP03_AMOUNT && !values.EXP03_CURR_ID) {
            errors.EXP03_CURR_ID = "Required";
          }

          // if (!values.EXP04_AMOUNT && values.EXP04_CURR_ID) {
          //   errors.EXP04_AMOUNT = "Required";
          // }

          if (values.EXP04_AMOUNT && !values.EXP04_CURR_ID) {
            errors.EXP04_CURR_ID = "Required";
          }

          return errors;
        }}
      >
        {(formikProps) => {
          const { submitForm, touched, errors, setFieldValue } = formikProps;

          return (
            <Form noValidate>
              <div>
                <Box display="flex" flexDirection="column">
                  <Box display="flex" justifyContent="center">
                    <Field
                      component={TextField}
                      name="EXP01_AMOUNT"
                      label="(+) Storeage"
                      error={Boolean(
                        errors.EXP01_AMOUNT &&
                          touched.EXP01_AMOUNT &&
                          errors.EXP01_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP01_CURR_ID &&
                            touched.EXP01_CURR_ID &&
                            errors.EXP01_CURR_ID
                        )}
                        id="EXP01_CURR_ID"
                      >
                        Select Currency Storeage
                      </InputLabel>
                      <Field
                        labelId="EXP01_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP01_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP01_CURR_ID &&
                            touched.EXP01_CURR_ID &&
                            errors.EXP01_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP01_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        <MenuItem key={0} value={null}>
                          None
                        </MenuItem>
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                  <Box display="flex" justifyContent="center">
                    <Field
                      component={TextField}
                      name="EXP02_AMOUNT"
                      label="(+) Insurance"
                      error={Boolean(
                        errors.EXP02_AMOUNT &&
                          touched.EXP02_AMOUNT &&
                          errors.EXP02_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP02_CURR_ID &&
                            touched.EXP02_CURR_ID &&
                            errors.EXP02_CURR_ID
                        )}
                        id="EXP02_CURR_ID"
                      >
                        Select Currency Insurance
                      </InputLabel>
                      <Field
                        labelId="EXP02_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP02_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP02_CURR_ID &&
                            touched.EXP02_CURR_ID &&
                            errors.EXP02_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP02_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        <MenuItem key={0} value={null}>
                          None
                        </MenuItem>
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                  <Box display="flex" justifyContent="center">
                    <Field
                      component={TextField}
                      name="EXP03_AMOUNT"
                      label="(+) Import duty"
                      error={Boolean(
                        errors.EXP03_AMOUNT &&
                          touched.EXP03_AMOUNT &&
                          errors.EXP03_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP03_CURR_ID &&
                            touched.EXP03_CURR_ID &&
                            errors.EXP03_CURR_ID
                        )}
                        id="EXP03_CURR_ID"
                      >
                        Select Currency Import duty
                      </InputLabel>
                      <Field
                        labelId="EXP03_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP03_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP03_CURR_ID &&
                            touched.EXP03_CURR_ID &&
                            errors.EXP03_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP03_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        <MenuItem key={0} value={null}>
                          None
                        </MenuItem>
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                  <Box display="flex" justifyContent="center">
                    <Field
                      component={TextField}
                      name="EXP04_AMOUNT"
                      label="(+) Other expense"
                      error={Boolean(
                        errors.EXP04_AMOUNT &&
                          touched.EXP04_AMOUNT &&
                          errors.EXP04_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP04_CURR_ID &&
                            touched.EXP04_CURR_ID &&
                            errors.EXP04_CURR_ID
                        )}
                        id="EXP04_CURR_ID"
                      >
                        Select Currency Other expense
                      </InputLabel>
                      <Field
                        labelId="EXP04_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP04_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP04_CURR_ID &&
                            touched.EXP04_CURR_ID &&
                            errors.EXP04_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP04_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        <MenuItem key={0} value={null}>
                          None
                        </MenuItem>
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={submitForm}
                    >
                      <SaveIcon />
                      Save
                    </Button>
                    <Button
                      autoFocus
                      variant="contained"
                      color="second"
                      onClick={(e) => {
                        e.preventDefault();
                        history.goBack();
                      }}
                    >
                      Back
                    </Button>
                  </Box>
                </Box>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  };

  return (
    <Page className={classes.root} title="Expense Form Edit">
      <Container maxWidth={false}>
        <Card>
          <CardContent>
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  history.replace("/purchase-requisition-list");
                }}
              >
                Purchase Requisition List
              </Link>
              <Link
                color="inherit"
                onClick={() => {
                  history.goBack();
                }}
              >
                Purchase Requesition Edit
              </Link>
              <Link color="textPrimary" aria-current="page">
                Expense Form Edit
              </Link>
            </Breadcrumbs>
            <Box display="flex" flexDirection="column">
              <Box>{renderForm()}</Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
